import script from "./WebView.vue?vue&type=script&setup=true&lang=js"
export * from "./WebView.vue?vue&type=script&setup=true&lang=js"

import "./WebView.vue?vue&type=style&index=0&id=19522b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19522b54"]])

export default __exports__